export default __webpack_public_path__ + "3a80ea98482e59db93bc002457323c74.wav";